import React, { useEffect, useState } from 'react';
import { useDesignTheme } from '../../hooks/useDesignTheme';

interface FloatingCodeItem {
  id: number;
  text: string;
  x: number;
  y: number;
  speed: number;
  opacity: number;
}

const floatingCodeSnippets = [
  'const', 'function', 'return', 'async', 'await',
  'class', 'interface', 'type', 'import', 'export',
  '{...}', '() =>', 'if', 'else', 'map()',
  'filter()', 'reduce()', 'useState', 'useEffect'
];

export function FloatingCode() {
  const { theme } = useDesignTheme();
  const [floatingCodes, setFloatingCodes] = useState<FloatingCodeItem[]>([]);

  // Initialize floating code snippets
  useEffect(() => {
    const codes: FloatingCodeItem[] = Array.from({ length: 15 }, (_, i) => ({
      id: i,
      text: floatingCodeSnippets[Math.floor(Math.random() * floatingCodeSnippets.length)],
      x: Math.random() * 100,
      y: Math.random() * 100,
      speed: 0.1 + Math.random() * 0.3,
      opacity: 0.1 + Math.random() * 0.2
    }));
    setFloatingCodes(codes);
  }, []);

  // Animate floating codes
  useEffect(() => {
    const interval = setInterval(() => {
      setFloatingCodes(prev => prev.map(code => ({
        ...code,
        y: code.y > 100 ? -10 : code.y + code.speed
      })));
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hidden md:block">
      {floatingCodes.map(code => (
        <div
          key={code.id}
          className="absolute font-mono text-xs pointer-events-none"
          style={{
            left: `${code.x}%`,
            top: `${code.y}%`,
            opacity: code.opacity,
            transform: 'translate(-50%, -50%)',
            color: theme.text
          }}
        >
          {code.text}
        </div>
      ))}
    </div>
  );
}
